import type { Topic } from "@/types/topic";
import TopicCard from "@/components/feature/TopicCard";

type RelatedTopicsProps = {
  items: Topic[];
};

export default function RelatedTopics({ items }: RelatedTopicsProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <section className="mt-12">
      <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        相关事件推荐
      </h2>
      <p className="mt-2 text-sm text-foreground-600">
        同样是材料存在分歧或结论发生过变化的事件，可以对照着看。
      </p>
      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        {items.map((topic) => (
          <TopicCard key={topic.id} topic={topic} variant="wide" />
        ))}
      </div>
    </section>
  );
}